<script setup lang="ts">
import type { StudyChanges } from '@/models';
import { useStudyStore } from '@/stores/study';

const studyStore = useStudyStore();

const getChange = (key: string) => {
  return studyStore.studyImportDiff?.studyConfigChanges.changes[
    key as keyof StudyChanges
  ] ||
    studyStore.studyImportDiff?.studyConfigChanges.changes[
      key as keyof StudyChanges
    ] === '' ?
    studyStore.studyImportDiff?.studyConfigChanges.changes[
        key as keyof StudyChanges
    ] :
    studyStore.studyImportDiff?.studyConfigChanges.previous[
        key as keyof StudyChanges
    ];
};

const getCssClass = (key: string, previous?: boolean): string => 
  studyStore.studyImportDiff?.studyConfigChanges.changes[key as keyof StudyChanges] === undefined ?
    'white' :
    studyStore.studyImportDiff?.studyConfigChanges.previous[key as keyof StudyChanges] !==
    studyStore.studyImportDiff?.studyConfigChanges.changes[key as keyof StudyChanges] ?
      (previous ? 'old' : 'new') : 'white';
</script>

<template>
  <div class="tab-root">
    <table className="study-config-table">
      <thead>
        <tr>
          <th>Title</th>
          <th>Case Management</th>
          <th>Webhook - Entry created</th>
          <th>Webhook - Entry updated</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td :class="getCssClass('title', true)">
            {{ studyStore.studyImportDiff?.studyConfigChanges.previous.title }}
          </td>
          <td :class="getCssClass('isCaseManagement', true)">
            {{
              JSON.stringify(
                studyStore.studyImportDiff?.studyConfigChanges.previous
                  .isCaseManagement
              )
            }}
          </td>
          <td :class="getCssClass('entryCreatedWebhook', true)">
            {{
              studyStore.studyImportDiff?.studyConfigChanges.previous
                .entryCreatedWebhook
            }}
          </td>
          <td :class="getCssClass('entryUpdatedWebhook', true)">
            {{
              studyStore.studyImportDiff?.studyConfigChanges.previous
                .entryUpdatedWebhook
            }}
          </td>
        </tr>

        <tr v-if="Object.keys(studyStore.studyImportDiff!.studyConfigChanges.changes).length > 0">
          <td :class="getCssClass('title')">
            {{ getChange('title') }}
          </td>
          <td :class="getCssClass('isCaseManagement')">
            {{
              getChange('isCaseManagement')
            }}
          </td>
          <td :class="getCssClass('entryCreatedWebhook')">
            {{
               getChange('entryCreatedWebhook')
            }}
          </td>
          <td :class="getCssClass('entryUpdatedWebhook')">
            {{
              getChange('entryUpdatedWebhook')
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
$old: #ffe8e9;
$new: #dcffdc;
.study-config-table {
  font-family: arial, sans-serif;
  border-collapse: collapse;

  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  .cell {
    display: flex;
    justify-content: space-between;

    .error {
      color: red;
    }
  }
}

.old {
  background-color: $old;
}

.new {
  background-color: $new;
}
</style>
